import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import ALIADO_VALOR_AGREGADO from "../../../assets/img/ALIADO_VALOR_AGREGADO.png";
import ALIADO_COLABORACION from "../../../assets/img/ALIADO_COLABORACION.png";
import ALIADO_REVENDEDOR from "../../../assets/img/ALIADO_REVENDEDOR.png";
import ALIADO_SOCIOS from "../../../assets/img/ALIADO_SOCIOS.png";
// import G_EVOLUTION_CARACTERISTICAS_IMG from "../../../assets/img/G_EVOLUTION_CARACTERISTICAS_IMG.jpg";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import content from "./content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const AlliesRevendedor = () => {
	const { language } = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();

  return (
		<>
			<ChangeableHeaderV2
				withTitle
				appearSecondNavbar={dropdownHeader} 
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].var_yellow_title}
					boldText={content[language].var_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{
						img: ALIADO_VALOR_AGREGADO,
						alt: "Tablet con Graficos en Pantalla",
					}}
					imgRadius
					boldText={content[language].var_bold_text}
					paragraphs={content[language].var_text}
				/>
			</div>

			<div className="top-space-section bottom-space-section padding light-blue-bg">
				<IndustryImageTextSection
					switchOrder
					image={{
						img: ALIADO_COLABORACION,
						alt: "ALIADO_COLABORACION",
					}}
					yellowText={content[language].var_yellow_title}
					boldText={content[language].var_bold_text_2}
					paragraphs={content[language].var_text_2}
				/>
			</div>

			<IndustryBannerBgSection route="my-tracker">
				<IndustryImageTextSection
					inBanner
					image={{
						img: ALIADO_REVENDEDOR,
						alt: "ALIADO_REVENDEDOR",
					}}
					imgRadius
					yellowText={content[language].var_yellow_title}
					boldText={content[language].var_bold_text_3}
					responsiveImgPosition="last"
				/>
			</IndustryBannerBgSection>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					switchOrder
					image={{
						img: ALIADO_SOCIOS,
						alt: "ALIADO_SOCIOS",
					}}
					yellowText={content[language].var_yellow_title}
					boldText={content[language].var_bold_text_3}
					paragraphs={content[language].var_text_4}
				/>
			</div>
		</>
	);
};

export default AlliesRevendedor;
